<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <ManagerSidebarMenu v-if="checkIsManager() || ($store.state.switch_flag == 'Manager')" :show_menu="false" :show_back_button="true" back_link="managerReports"></ManagerSidebarMenu>
      <ManagerSidebarMenu v-if="checkIsMentor() || ($store.state.switch_flag == 'Mentor')" :show_menu="false" :show_back_button="true" back_link="mentorReports"></ManagerSidebarMenu>
      
      <div class="content-wrapper" style="padding-left: 165px;">
        <div class="container-wrapper center ml-2">

          <div class="row mt-3 mb-3 border-bottom pb-2">
            <div class="col p-0">
              <div class="h4 text-uppercase">Skill Set Progress</div>
            </div>
          </div>
					<header class="report-header" v-if="loading == false">
						<div>
							<h2 id="skill-report-title">{{ account_name }}</h2>
							<p>
								<span class="acc-info">{{ account_address ? account_address + ',' : '' }}</span>
								<span class="acc-info">{{ account_city ? account_city + ',' : '' }}</span>
								<span class="acc-info">{{ account_state ? account_state + ' ' : '' }}</span>
								<span class="acc-info">{{ account_zip ? account_zip : '' }}</span>
							</p>
						</div>
						<div class="action-buttons" v-if="report.skillSets.length > 0">
							<button class="button button-outline" type="button" :disabled="downloading" @click="download">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-download mr-2 h-4 w-4" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/reports/SkillSetReportActions.tsx:53:10" data-component-name="Download"><path d="M12 15V3"></path><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><path d="m7 10 5 5 5-5"></path></svg>
								{{ downloading ? "Creating PDF…" : "Download PDF" }}
							</button>
							<button class="button button-primary" type="button"  @click="shareButtonModal()">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-send mr-2 h-4 w-4" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/reports/SkillSetReportActions.tsx:56:10" data-component-name="Send"><path d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"></path><path d="m21.854 2.147-10.94 10.939"></path></svg>
                 Send
							</button>
						</div>
					</header>

          <div class="row " v-if="loading == true">
              <div class="col-4 pl-0" style="text-align: left;">
                <PuSkeleton :count="1" height="40px" width=""></PuSkeleton>
              </div>
              <div class="col-5 pl-0">
              </div>
              <div class="col-3 pl-0 pr-0">
                <PuSkeleton height="40px" :count="1"></PuSkeleton>
              </div>
          </div>

          <div class="text-center pt-4" v-if="loading == true">
            <div class="row" v-for="option in 7">
              <div class="field_1 p-0" style="float: left; width: 70%; padding-left: 15px;"><PuSkeleton height="30px" :count="1"></PuSkeleton></div>
              <div class="field_2 p-0" style="text-align: right; float: right; width: 20%; padding-left: 15px;">&nbsp;</div>
              <div class="field_2 p-0" style="text-align: right; float: right; width: 10%; padding-left: 15px;"><PuSkeleton height="30px" :count="1"></PuSkeleton></div>
              <div class="col-12 py-2 px-0">
                <div class="custom_hr"></div>
              </div>
            </div>
          </div>


					<div class="skill-sets" v-if="loading == false">
						<article v-for="skillSet in report.skillSets" :key="skillSet.id" class="accordion-item">
							<button class="accordion-trigger" type="button" :aria-expanded="isSetOpen(skillSet.id)" @click="toggleSet(skillSet.id)">
								<span class="skillsetname">{{ skillSet.name }}</span>
								<span class="trigger-end">
									<span class="percentage" :style="progressStyle(skillSet.averagePercent)">Avg: {{ formatPercent(skillSet.averagePercent) }}</span>
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/ui/accordion.tsx:35:6" data-component-name="ChevronDown"><path d="m6 9 6 6 6-6"></path></svg>
								</span>
							</button>
							<div v-show="isSetOpen(skillSet.id)" class="accordion-panel">
								<p v-if="!skillSet.mentees.length" class="empty">No mentees found for this skill set.</p>
								<article v-for="mentee in skillSet.mentees" v-else :key="mentee.id + '-' + skillSet.id" class="mentee">
									<button class="mentee-trigger" type="button" :aria-expanded="isMenteeOpen(skillSet.id, mentee.id)" @click="toggleMentee(skillSet.id, mentee.id)">
										<span class="menteename">{{ mentee.name }}</span>
										<span class="trigger-end">
											<span class="percentage percentage-small" :style="progressStyle(mentee.percent)">{{ formatPercent(mentee.percent) }}</span>
											<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/ui/accordion.tsx:35:6" data-component-name="ChevronDown"><path d="m6 9 6 6 6-6"></path></svg>
										</span>
									</button>
									<div v-show="isMenteeOpen(skillSet.id, mentee.id)" class="skills">
										<p v-if="!mentee.skills.length" class="empty">No skills listed.</p>
										<div v-for="skill in mentee.skills" v-else :key="skill.id + '-' + mentee.id + '-' + skillSet.id" class="skill-row">
											<span class="skill-name">
                        <span aria-hidden="true" v-if="skill.completed == 1"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-check w-4 h-4 text-emerald-500 shrink-0 mt-0.5" data-replit-metadata="artifacts/analytics-dashboard/src/components/reports/SkillSetProgressReport.tsx:207:38" data-component-name="CheckCircle2" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="m9 12 2 2 4-4"></path></svg></span>
                        <span aria-hidden="true" v-else><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle w-4 h-4 text-muted-foreground shrink-0 mt-0.5" data-replit-metadata="artifacts/analytics-dashboard/src/components/reports/SkillSetProgressReport.tsx:209:38" data-component-name="Circle" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle></svg></span>
                      {{ skill.name }}</span>
											<span class="competencies">{{ skillStatus(skill) }}</span>
										</div>
									</div>
								</article>
							</div>
						</article>
						<div class="text-center p-4" v-if="report.skillSets.length == 0 && loading == false">
							No skill set found!
						</div> 
					</div>

        </div>
      </div>
    </div>


    <ShareReportModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Share Report</h3></div>
      <div slot="body">
        <div v-if="showShareSuccess == true" class="col-12 override-padding" style="color: #68C47E; text-align: center; margin-bottom: 15px;">
          <b>Report shared successfully!</b>
        </div>
        <div class="col-12 override-padding">
          <input v-model="share_email"
                name="share_email"
                placeholder="Enter Email..."
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required|email'"
                data-vv-as="Email address"
                maxlength="255"
                @keyup="checkEmail()" />
         <div v-show="verrors.has('share_email')" class="validate-warning-msg">{{ verrors.first('share_email') }}</div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>

        <div v-if="showWait == false" class="col-12 override-padding text-align-right">
            <button :disabled="share_button_disable" v-on:click="shareButtonSubmit()"
                class="btn ma-blue-btn col-3 input-height-25 createBtn"
                style="line-height: 30px; border-radius: 10px;"><b>{{ submit_text }}</b></button>
        </div>
        <div v-if="showWait == true" class="col-12 override-padding text-align-right">
            <button disabled="true" class="btn ma-blue-btn col-lg-3"
                style="line-height: 30px; border-radius: 10px;"><b>Please wait...</b></button>
        </div>

      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </ShareReportModal>


  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import UserMenu from '../shared/user_menu.vue';
import ManagerSidebarMenu from '@/components/shared/manager_sidebar_menu.vue';
import MentorSidebarMenu from '@/components/shared/mentor_sidebar_menu.vue';
import { checkIsManager, checkIsMentor } from '@/components/shared/utils.js';
import ShareReportModal from '../enterpriseadmin/share_email_report_modal.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  components: {
    UserMenu,
    ManagerSidebarMenu,
    MentorSidebarMenu,
    ShareReportModal,
  },
  data() {
    return {
      loading: false,
      showOverlay: false,
      results: [],
      apiUrl: '',
      isModalVisible: false,

			report: {
				skillSets: [],
			},
			openSets: {},
			openMentees: {},
			downloading: false,
			downloadError: "",
			recipients: "",
			account_name: '',
			account_address: '',
			account_city: '',
			account_state: '',
			account_zip: '',
      isModalVisible: false,
      submit_text: 'Submit',
      share_email: '',
      showShareSuccess: false,
      showWait: false,
    }
  },
  computed: {
    
  },
  methods: {
    shareButtonSubmit: function() {
      this.$validator.validateAll().then((result) => {
        if ((this.verrors.items.length === 0)) {
          this.submit_text = 'Please wait...';
          this.showWait = true;
          axios('/manager-skill-set-report-pdf-share',
              {
                method: 'POST',
                data:
                {
                  email: this.share_email,
                  account_id: this.$store.state.user_accountid, 
                },
              }
            )
          .then((resp) => {
            this.share_email = '';
            this.submit_text = 'Submit';
            this.showWait = false;
            this.showShareSuccess = true;
            setTimeout(() => {
                this.showShareSuccess = false;
            }, 5000)

            })
          .catch(error => {

          });
        }
      });

    },
    shareButtonModal() {
      this.isModalVisible = true;
    },
    checkIsMentor() {
      return checkIsMentor();
    },
    checkIsManager() {
      return checkIsManager();
    },
    async download() {
      this.downloading = true;
      this.downloadError = "";
      axios('/manager-skill-set-report-pdf', {
        method: 'GET',
        params: {
          accountId: this.$store.state.user_accountid, 
        }
      })
      .then(response =>  {
				this.downloading = false;
        this.pdf_file_name = response.data.pdf_file_name;
          var url = this.apiUrl + '/custom/pdf-view/' + this.pdf_file_name;

        //Create XMLHTTP Request.
        var req = new XMLHttpRequest();
        req.open("GET", url, true);
        req.responseType = "blob";
        req.onload = function () {
            //Convert the Byte Data to BLOB object.
            var blob = new Blob([req.response], { type: "application/octetstream" });

            //Check the Browser type and download the File.
            var isIE = false || !!document.documentMode;
            if (isIE) {
                window.navigator.msSaveBlob(blob, fileName);
            } else {
                var url = window.URL || window.webkitURL;
                var link = url.createObjectURL(blob);
                var a = document.createElement("a");
                a.setAttribute("download", "skill-set-progress.pdf");
                a.setAttribute("href", link);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        };
        req.send();
        return false;
      })
      .catch(function() { });
    },
		async loadReport() {
      this.loading = true;
      axios('/manager-skill-set-report', {
        method: 'GET',
        params: {
          accountId: this.$store.state.user_accountid, 
        }
      })
      .then(response =>  {
        this.loading = false;
				this.report.skillSets = response.data.skillSets;
				this.account_name = response.data.account_name;
				this.account_address = response.data.account_address;
				this.account_city = response.data.account_city;
				this.account_state = response.data.account_state;
				this.account_zip = response.data.account_zip;
      })
      .catch(function() { });

		},
		formatPercent(value) { return value == null ? "Not tracked" : `${Math.round(value)}%`; },
		progressStyle(value) {
      if (value == null) return {};
      const displayed = Math.round(value);
      const backgroundColor = displayed < 33 ? "#EE4200" : displayed < 66 ? "#f4d454" : "#009118";
      return { backgroundColor, borderColor: backgroundColor, color: displayed < 33 || displayed >= 66 ? "#fff" : "#002f42" };
    },
    isSetOpen(id) { return Boolean(this.openSets[id]); },
    toggleSet(id) { this.$set(this.openSets, id, !this.openSets[id]); },
    menteeKey(setId, menteeId) { return `${setId}:${menteeId}`; },
    isMenteeOpen(setId, menteeId) { return Boolean(this.openMentees[this.menteeKey(setId, menteeId)]); },
    toggleMentee(setId, menteeId) {
      const key = this.menteeKey(setId, menteeId);
      this.$set(this.openMentees, key, !this.openMentees[key]);
    },
    statusClass(value) { return value == null ? "unknown" : value ? "complete" : "incomplete"; },
    statusIcon(value) { return value == null ? "?" : value ? "✓" : ""; },
    skillStatus(skill) {
      return skill.completedReps == null || skill.requiredReps == null
        ? "Not tracked"
        : `${skill.completed ? "Completed" : "Incomplete"} · ${skill.completedReps} / ${skill.requiredReps} Competencies`;
    }
  },
  created() {
    this.apiUrl = process.env.API_ENDPOINT;
    this.loadReport();
  }
}
</script>

<style scoped>
.report_heading {   
    font-size: 14px; 
    padding-top: 8px;
    padding-bottom: 8px;
    font-weight: bold;
}
.custom_heading_hr, .custom_hr {
  width: 100%;
  margin: 5px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.custom_heading_hr {
    border-bottom: 3px solid #A3A3A3;
}
.field_1 {
  width: 5%;
  padding-left: 15px;
}
.field_3, .field_4, .field_5, .field_6, .field_7, .field_8, .field_9 {
  width: 11%;
  text-align: center;
}
.field_9 {
  padding-right: 15px;
}
.field_2 {
  width: 15%;
}
.field_3 {
  width: 13%;
}
.btn:disabled {
    background-color: #8b8b8b;
    color: #FFF;
}

.skill-report{box-sizing:border-box;width:100%;max-width:1024px;margin:0 auto;color:#002f42;font-family:Inter,system-ui,-apple-system,sans-serif}.report-header{display:flex;align-items:flex-start;justify-content:space-between;gap:24px;margin-bottom:24px}.report-header h2{margin:0;font-size:24px;line-height:1.2}.report-header p,.demo-note{margin:5px 0 0;color:#667780;font-size:14px}.skill-sets{overflow:hidden;border:1px solid #d6dde1;border-radius:10px;background:#fff;box-shadow:0 1px 3px rgba(0,47,66,.08); margin-bottom: 30px;}.accordion-item:not(:last-child),.mentee:not(:last-child){border-bottom:1px solid #e4e9eb}.accordion-trigger,.mentee-trigger{display:flex;align-items:center;justify-content:space-between;gap:16px;width:100%;border:0;background:#fff;padding:17px 24px;color:#002f42;text-align:left;font:500 15px/1.4 system-ui;cursor:pointer}.accordion-trigger:hover,.mentee-trigger:hover{background:#f5f8f9}.accordion-trigger:focus-visible,.mentee-trigger:focus-visible,.retry:focus-visible{position:relative;z-index:1;outline:3px solid rgba(0,172,238,.3);outline-offset:-3px}.trigger-end{display:flex;align-items:center;gap:14px;flex-shrink:0}.percentage{display:inline-block;border:1px solid #d6dde1;border-radius:999px;background:#edf1f3;padding:4px 12px;white-space:nowrap;font-size:14px;font-weight:500}.percentage-small{border-radius:5px;padding:3px 8px;font:500 12px/1.2 ui-monospace,monospace}.chevron{font-size:19px}.accordion-panel{border-top:1px solid #e4e9eb;background:#fafbfb}.mentee-trigger{padding:13px 32px;font-size:14px}.skills{padding:15px 32px 18px;background:#f9f8fb}.skills>.skill-row:first-of-type{border-radius:7px 7px 0 0}.skills>.skill-row:last-child{border-radius:0 0 7px 7px}.skill-row{display:flex;align-items:flex-start;justify-content:space-between;gap:20px;border:1px solid #e0e5e7;border-bottom:0;padding:13px 14px;font-size:14px}.skill-row:last-child{border-bottom:1px solid #e0e5e7}.skill-name{display:flex;min-width:0;gap:10px;font-weight:400}.status-icon{display:inline-grid;place-items:center;flex:0 0 17px;width:17px;height:17px;border:1px solid currentColor;border-radius:50%;font-size:11px;margin-top: 1px;}.complete{color:#009118}.incomplete,.unknown{color:#7c8b92}.competencies{flex-shrink:0;border-radius:4px;background:#f0f3f4;padding:3px 6px;color:#667780;white-space:nowrap;font:12px/1.2 ui-monospace,monospace}.empty,.state{margin:0;padding:32px;text-align:center;color:#667780}.state{border:1px dashed #d6dde1;border-radius:8px}.state strong{display:block;color:#002f42;font-size:18px}.state-error{color:#b42318}.retry{border:0;border-radius:7px;background:#002f42;padding:9px 14px;color:#fff;font-weight:600;cursor:pointer}.demo-note{font-size:12px}@media(max-width:760px){.report-header{flex-direction:column;gap:16px}.report-header h2{font-size:21px}.accordion-trigger{align-items:flex-start;padding:15px 13px}.accordion-trigger>.trigger-end{align-items:flex-end;flex-direction:column-reverse;gap:5px}.mentee-trigger{padding:12px 16px}.skills{padding:9px 12px 15px}.skill-row{flex-direction:column;gap:8px}.competencies{margin-left:27px;white-space:normal}}

.report-actions,.action-buttons{display:flex}.report-actions{flex-direction:column;gap:8px;flex-shrink:0}.action-buttons{flex-wrap:wrap;gap:8px}.button{display:inline-flex;align-items:center;justify-content:center;gap:8px;border:1px solid transparent;border-radius:7px;padding:9px 14px;font:500 14px/1 system-ui;cursor:pointer}.button:focus-visible,input:focus-visible,textarea:focus-visible,.modal-close:focus-visible{outline:3px solid rgba(0,172,238,.3);outline-offset:2px}.button:disabled{opacity:.6;cursor:wait}.button-primary{background:#00acf0;color:#fff}.button-primary:hover{background:#00acf0}.button-outline{background:#fff;border-color:#d6dde1;color:#002f42}.error{color:#b42318;font-size:13px}.modal-layer{position:fixed;inset:0;z-index:1000;display:grid;place-items:center;padding:16px;background:rgba(0,20,30,.64)}.modal{position:relative;width:min(520px,100%);max-height:90vh;overflow:auto;border-radius:12px;background:#fff;padding:24px;box-shadow:0 24px 70px rgba(0,0,0,.3);color:#002f42}.modal-close{position:absolute;top:12px;right:14px;border:0;background:transparent;font-size:26px;cursor:pointer}.modal header h3{margin:0 30px 4px 0;font-size:20px}.modal header p{margin:0 0 16px;color:#667780;font-size:14px}.notice,.success{border:1px solid #d6dde1;border-radius:7px;background:#f4f7f8;padding:12px;font-size:13px}.modal form{display:grid;gap:8px;margin-top:16px}.modal label{margin-top:8px;font-weight:600;font-size:14px}.modal label span,.modal small{display:block;color:#667780;font-weight:400;font-size:12px}.modal input,.modal textarea{box-sizing:border-box;width:100%;border:1px solid #bdc9ce;border-radius:7px;padding:10px 11px;font:14px system-ui;resize:vertical}.attachment{display:flex;gap:12px;margin-top:8px;border:1px solid #d6dde1;border-radius:7px;padding:12px}.attachment small{margin-top:3px}.modal footer{display:flex;flex-wrap:wrap;justify-content:flex-end;gap:8px;margin-top:10px}@media(max-width:600px){.action-buttons .button{flex:1}.modal{padding:20px}.modal footer .button{flex:1}}

.accordion-trigger {
  font:500 16px/1.4 system-ui;  
}
[aria-expanded="true"] svg {
  rotate: 180deg;
}
.text-emerald-500 {
    color: #00bc7d;
}
.sub-heading h3 {
  font-size: 19px;
  color: #002f42;
}
.sub-heading {
  margin-left: 5px;
}
.text-muted-foreground {
  color: #627384;
}
.button-outline:hover {
  background-color: rgb(0, 0, 0, .03);
}
.button-primary:hover {
  background-color: #0099D6;
}
.accordion-trigger .skillsetname:hover, .mentee-trigger .menteename:hover {
  color: #00ACEE;
}
.lucide-circle-check, .lucide-circle {
  transform: translateY(-1px);
}
</style>



// WEBPACK FOOTER //
// src/components/manager/manager_skill_set_reports.vue